(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "babel-runtime/helpers/extends", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/helpers/extends"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react);
    global.PeachjarLogoLight = mod.exports;
  }
})(this, function (exports, _extends2, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PeachjarLogoLight = function PeachjarLogoLight(props) {
    return React.createElement(
      "svg",
      (0, _extends3.default)({
        width: "120px",
        height: "38px",
        viewBox: "0 0 120 38",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, props),
      React.createElement(
        "title",
        null,
        "Peachjar Logo - Light Version"
      ),
      React.createElement(
        "defs",
        null,
        React.createElement("path", {
          d: "M6.179,10.8256098 C5.376625,10.8417073 4.586125,10.6332927 3.90075,10.225122 C3.2795,9.82804878 2.76525,9.29036585 2.401875,8.65768293 L2.401875,14.8832927 L0.093625,14.8832927 L0.093625,0.132439024 L2.087125,0.132439024 L2.087125,2.02207317 C2.491375,1.41841463 3.03575,0.916463415 3.675875,0.557195122 C4.345125,0.179634146 5.10675,-0.012804878 5.87925,0.000609756098 C6.579625,-0.00890243902 7.2725,0.141585366 7.90275,0.44 C8.511875,0.728780488 9.056875,1.13195122 9.5065,1.62658537 C9.968625,2.11890244 10.334375,2.6897561 10.58575,3.31109756 C10.83675,3.97195122 10.96375,4.67158537 10.9605,5.37646341 C10.95675,6.09987805 10.830125,6.81768293 10.58575,7.5004878 C10.36775,8.1104878 10.037625,8.67646341 9.6115,9.17036585 C9.196,9.65012195 8.686375,10.0436585 8.112625,10.327561 C7.51875,10.6440244 6.85525,10.814878 6.179,10.8256098 Z M5.444625,8.93597561 C5.8985,8.94 6.3465,8.83426829 6.748625,8.62841463 C7.135625,8.42890244 7.47725,8.15487805 7.752875,7.82280488 C8.03625,7.48280488 8.2545,7.09585366 8.397375,6.6802439 C8.546625,6.25597561 8.622625,5.8104878 8.62225,5.36182927 C8.62525,4.89621951 8.538875,4.43402439 8.367375,3.9995122 C8.2045,3.585 7.96575,3.20280488 7.662875,2.87158537 C7.3695,2.55097561 7.012625,2.29182927 6.61375,2.10987805 C6.1955,1.92207317 5.74,1.82695122 5.27975,1.83158537 C4.972875,1.83609756 4.668875,1.8904878 4.380375,1.99268293 C4.066125,2.09841463 3.7685,2.24634146 3.496,2.43219512 C3.226625,2.61317073 2.9845,2.83012195 2.776625,3.07670732 C2.576125,3.31292683 2.428,3.58719512 2.341875,3.88231707 L2.341875,6.62158537 C2.480875,6.94585366 2.66225,7.25109756 2.8815,7.5297561 C3.09325,7.79926829 3.340125,8.04060976 3.616,8.24756098 C3.88075,8.44829268 4.1735,8.61109756 4.485375,8.73097561 C4.789,8.85768293 5.1145,8.92731707 5.444625,8.93597561 Z",
          id: "path-1"
        }),
        React.createElement("path", {
          d: "M5.54226966,10.9718889 C4.76992135,10.9841111 4.00325843,10.8392778 3.28961798,10.5461889 C2.63740449,10.2748556 2.04748315,9.87531111 1.55569663,9.37175556 C1.07441573,8.87174444 0.696831461,8.28324444 0.444078652,7.63937778 C0.177730337,6.9762 0.0418988764,6.26853333 0.044,5.55475556 C0.0402921348,4.8312 0.176123596,4.11363333 0.444078652,3.44067778 C0.697449438,2.79277778 1.07491011,2.19951111 1.55569663,1.69363333 C2.04476404,1.18323333 2.63517978,0.778311111 3.28961798,0.504533333 C4.00832584,0.211077778 4.77993258,0.0661222222 5.55710112,0.0787111111 C6.32611236,0.0675888889 7.08869663,0.217677778 7.79504494,0.5192 C8.44021348,0.7953 9.02432584,1.19435556 9.51413483,1.69363333 C9.99726966,2.19498889 10.3705281,2.78972222 10.6109213,3.44067778 C10.8593483,4.09273333 10.9849213,4.78438889 10.9814607,5.4813 C10.9814607,5.64275556 10.9814607,5.78954444 10.9814607,5.93645556 C10.9814607,6.08324444 10.9814607,6.2007 10.9814607,6.2887 L2.41517978,6.2887 C2.44978652,6.72674444 2.56522472,7.15476667 2.75605618,7.55125556 C2.9315618,7.9145 3.17269663,8.24291111 3.46747191,8.52023333 C4.05034831,9.07072222 4.82591011,9.37591111 5.63125843,9.37175556 C5.93147191,9.36955556 6.23020225,9.3302 6.52052809,9.2543 C6.80121348,9.18414444 7.07052809,9.07548889 7.32080899,8.93126667 C7.56144944,8.79132222 7.78095506,8.61825556 7.97289888,8.41744444 C8.15594382,8.22237778 8.30598876,7.99932222 8.41747191,7.75683333 L10.3292472,8.29998889 C9.93683146,9.11594444 9.3004382,9.79256667 8.50646067,10.2379444 C7.60557303,10.7484667 6.57973034,11.0024444 5.54226966,10.9718889 Z M8.72868539,4.7179 C8.71101124,4.27753333 8.61052809,3.84437778 8.43230337,3.44067778 C8.26322472,3.08171111 8.02678652,2.75794444 7.7357191,2.48636667 C7.4471236,2.22041111 7.11020225,2.01116667 6.74275281,1.86975556 C6.36034831,1.72186667 5.95297753,1.64706667 5.54226966,1.64963333 C4.74013483,1.64743333 3.96704494,1.94651111 3.37860674,2.48636667 C3.0911236,2.75782222 2.85962921,3.08183333 2.69685393,3.44067778 C2.51776404,3.82506667 2.40739326,4.23732222 2.37080899,4.65911111 L8.72868539,4.7179 Z",
          id: "path-3"
        }),
        React.createElement("path", {
          d: "M3.60261905,10.9718889 C3.11559524,10.9841111 2.63083333,10.8992889 2.17511905,10.7223111 C1.76857143,10.5678222 1.3952381,10.3335222 1.07583333,10.0323667 C0.768452381,9.73793333 0.520952381,9.38361111 0.347857143,8.99005556 C0.172261905,8.57841111 0.0846428571,8.13278889 0.090952381,7.68337778 C0.0838095238,7.21331111 0.191785714,6.74874444 0.405,6.33282222 C0.620952381,5.92203333 0.923333333,5.56587778 1.29,5.29038889 C1.7202381,4.97151111 2.20428571,4.73757778 2.7175,4.60044444 C3.28404762,4.43666667 3.87059524,4.35758889 4.45904762,4.36553333 C4.9377381,4.36614444 5.41547619,4.41026667 5.88654762,4.49765556 C6.3197619,4.57416667 6.74511905,4.69211111 7.15702381,4.85002222 L7.15702381,4.13062222 C7.19666667,3.45864444 6.96416667,2.79974444 6.51464286,2.31024444 C6.00488095,1.84848889 5.33654762,1.61577778 4.65892857,1.6643 C4.10738095,1.66381111 3.56047619,1.76831111 3.04583333,1.97254444 C2.4722619,2.20696667 1.92630952,2.50738889 1.41845238,2.86806667 L0.761785714,1.40005556 C1.96107143,0.527877778 3.39,0.0517 4.85880952,0.0347111111 C6.04964286,-0.0419222222 7.22404762,0.351877778 8.14202381,1.13581111 C8.95940476,1.96912222 9.38630952,3.12546667 9.31261905,4.30686667 L9.31261905,8.1092 C9.31261905,8.57902222 9.49809524,8.81381111 9.88357143,8.82847778 L9.88357143,10.7811 L9.34119048,10.8544333 L8.89857143,10.8544333 C8.54738095,10.8735 8.20178571,10.7584889 7.92785714,10.5315222 C7.70202381,10.3147 7.55571429,10.0243 7.51392857,9.70933333 L7.51392857,9.04872222 C7.07809524,9.67278889 6.49952381,10.1769556 5.82952381,10.5168556 C5.13130952,10.8433111 4.36904762,10.9990222 3.60261905,10.9718889 Z M4.18785714,9.31296667 C4.6775,9.30893333 5.16190476,9.20932222 5.61535714,9.01938889 C6.04071429,8.85487778 6.41535714,8.57596667 6.7002381,8.21198889 C6.94333333,8.03488889 7.09559524,7.75426667 7.11416667,7.44858889 L7.11416667,6.08324444 C6.73952381,5.93474444 6.3525,5.82181111 5.95797619,5.74554444 C5.5627381,5.66781111 5.16119048,5.62857778 4.75880952,5.62808889 C4.09464286,5.59924444 3.43761905,5.77842222 2.87452381,6.14191111 C2.41857143,6.42998889 2.14238095,6.94234444 2.14654762,7.49258889 C2.13857143,7.99797778 2.34738095,8.48124444 2.7175,8.81381111 C3.12642857,9.1696 3.65345238,9.34853333 4.18785714,9.31296667 Z",
          id: "path-5"
        }),
        React.createElement("path", {
          d: "M0.0402409639,5.43557143 C0.04,4.74051648 0.167349398,4.05138462 0.415903614,3.40286813 C0.901927711,2.09145055 1.90578313,1.04040659 3.18975904,0.498989011 C3.89024096,0.208395604 4.64240964,0.065032967 5.40012048,0.0778461538 C6.36783133,0.0530659341 7.32325301,0.299417582 8.15951807,0.789340659 C8.9060241,1.2313956 9.50831325,1.88220879 9.89313253,2.66236264 L7.76939759,3.40286813 C7.53084337,2.97398901 7.18144578,2.61787912 6.75819277,2.37201099 C6.31879518,2.12021978 5.81903614,1.99462637 5.31349398,2.00901099 C4.47349398,2.00163736 3.67192771,2.36197802 3.11746988,2.99635165 C2.83385542,3.31994505 2.61337349,3.69430769 2.4673494,4.09973626 C2.30156627,4.56524176 2.22313253,5.05758242 2.23626506,5.55173626 C2.2246988,6.0470989 2.30807229,6.54004396 2.48180723,7.00373626 C2.63361446,7.414 2.85879518,7.79295604 3.14638554,8.12174725 C3.42156627,8.4318022 3.75554217,8.68347253 4.12879518,8.86225275 C4.50385542,9.03861538 4.91373494,9.12794505 5.32795181,9.12359341 C5.59674699,9.12069231 5.8639759,9.08164835 6.12253012,9.00742857 C6.37590361,8.93913187 6.61891566,8.83662637 6.84481928,8.70245055 C7.05650602,8.57310989 7.25072289,8.41693407 7.42277108,8.23791209 C7.57759036,8.0791978 7.70024096,7.89183516 7.78385542,7.6860989 L9.92204819,8.32494505 C9.56024096,9.12734066 8.95951807,9.79701099 8.20289157,10.2416044 C7.32939759,10.7595714 6.32710843,11.0164396 5.31349398,10.981989 C4.55915663,10.9928681 3.81108434,10.8445495 3.11746988,10.5464615 C2.49807229,10.2153736 1.95253012,9.76086813 1.51385542,9.21062637 C1.0473494,8.71417582 0.679638554,8.13262637 0.430361446,7.49740659 C0.17060241,6.8413956 0.0381927711,6.14150549 0.0402409639,5.43557143 Z",
          id: "path-7"
        }),
        React.createElement("path", {
          d: "M8.86673077,13.9084793 L6.77746154,13.9084793 L6.77746154,8.34932231 C6.83146154,7.63879339 6.66207692,6.92907438 6.29319231,6.32036364 C5.96988462,5.88381818 5.45053846,5.63864463 4.90961538,5.66710744 C4.61123077,5.66733884 4.3155,5.72391736 4.038,5.83383471 C3.73811538,5.95231405 3.45807692,6.11638017 3.20780769,6.32036364 C2.94473077,6.53279339 2.71188462,6.7806281 2.51607692,7.05692562 C2.31346154,7.34467769 2.15919231,7.66401653 2.0595,8.00198347 L2.0595,13.9084793 L0.0533076923,13.9084793 L0.0533076923,0.0107603306 L2.12861538,0.0107603306 L2.12861538,5.94502479 C2.8635,4.59593388 4.278,3.76264463 5.80892308,3.77699174 C6.33623077,3.7568595 6.85996154,3.87163636 7.33096154,4.11056198 C7.71726923,4.32333884 8.04530769,4.62890909 8.28553846,5.00008264 C8.53234615,5.3898843 8.7015,5.8241157 8.78365385,6.27859504 C8.87965385,6.79173554 8.92592308,7.31309091 8.922,7.8351405 L8.86673077,13.9084793 Z",
          id: "path-9"
        }),
        React.createElement("path", {
          d: "M2.58192,18.929875 C2.127,18.933375 1.67472,18.85725 1.2438,18.704625 C0.825,18.554625 0.43872,18.32 0.10704,18.014 L1.07112,16.5125 C1.23996,16.6765 1.44144,16.7995 1.66104,16.872875 C1.8744,16.94825 2.09772,16.98875 2.32296,16.993 C3.11772,16.993 3.76188,16.32075 3.76188,15.491625 L3.76188,4.26075 L5.92032,4.26075 L5.92032,15.236375 C5.92908,15.749625 5.841,16.259875 5.66124,16.73775 C5.49204,17.17425 5.2428,17.572 4.92744,17.908875 C4.6212,18.238 4.254,18.4985 3.84828,18.674625 C3.44616,18.845125 3.01596,18.931875 2.58192,18.929875 Z M3.79068,2.489 L3.79068,0.011625 L5.94912,0.011625 L5.94912,2.504 L3.79068,2.489 Z",
          id: "path-11"
        }),
        React.createElement("path", {
          d: "M3.56452381,10.9718889 C3.0775,10.9841111 2.59285714,10.8992889 2.13702381,10.7223111 C1.73059524,10.5678222 1.3572619,10.3335222 1.03785714,10.0323667 C0.729880952,9.73854444 0.482261905,9.3841 0.309880952,8.99005556 C0.128928571,8.57963333 0.0364285714,8.13401111 0.0386904762,7.68337778 C0.0604761905,7.22186667 0.192857143,6.77306667 0.424047619,6.37682222 C0.639642857,5.96578889 0.942142857,5.60963333 1.30904762,5.33451111 C1.73928571,5.01563333 2.22333333,4.78157778 2.73666667,4.64444444 C3.30321429,4.48078889 3.8897619,4.40158889 4.47821429,4.40965556 C4.95690476,4.41014444 5.43452381,4.45438889 5.90571429,4.54177778 C6.33880952,4.61865556 6.76416667,4.7366 7.17619048,4.89402222 L7.17619048,4.17474444 C7.21571429,3.50264444 6.98321429,2.84374444 6.53380952,2.35424444 C6.02404762,1.89248889 5.35571429,1.6599 4.67797619,1.7083 C4.12642857,1.70781111 3.57952381,1.81231111 3.065,2.01666667 C2.49142857,2.25108889 1.94547619,2.55151111 1.43761905,2.91218889 L0.780952381,1.44405556 C1.9802381,0.572 3.40916667,0.0958222222 4.87785714,0.0787111111 C6.06869048,0.00207777778 7.24309524,0.396 8.16107143,1.17981111 C8.97857143,2.01324444 9.40535714,3.16958889 9.33166667,4.35086667 L9.33166667,8.1532 C9.33166667,8.62302222 9.5172619,8.85793333 9.90261905,8.8726 L9.90261905,10.7811 L9.3602381,10.8544333 L8.84630952,10.8544333 C8.49511905,10.8735 8.14952381,10.7584889 7.87559524,10.5315222 C7.6497619,10.3147 7.50345238,10.0243 7.46166667,9.70933333 L7.46166667,9.04872222 C7.02583333,9.67278889 6.4472619,10.1769556 5.77714286,10.5168556 C5.08357143,10.8416 4.32630952,10.9973111 3.56452381,10.9718889 Z M4.14988095,9.31296667 C4.63940476,9.30856667 5.12380952,9.20895556 5.57738095,9.01938889 C6.0027381,8.85487778 6.37738095,8.57596667 6.6622619,8.21198889 C6.90535714,8.03488889 7.05761905,7.75426667 7.07619048,7.44858889 L7.07619048,6.08324444 C6.70154762,5.93474444 6.31452381,5.82181111 5.92,5.74554444 C5.5247619,5.66781111 5.12321429,5.62845556 4.72083333,5.62808889 C4.05666667,5.59924444 3.39952381,5.77842222 2.83654762,6.14191111 C2.38059524,6.42998889 2.10440476,6.94234444 2.10857143,7.49258889 C2.10059524,7.99797778 2.30940476,8.48124444 2.67952381,8.81381111 C3.08833333,9.1696 3.61535714,9.34853333 4.14988095,9.31296667 Z",
          id: "path-13"
        }),
        React.createElement("path", {
          d: "M5.85768,2.087625 C5.07876,2.098 4.31376,2.304 3.62736,2.688125 C2.9808,3.029375 2.47104,3.598625 2.18844,4.29475 L2.18844,10.901125 L0.0588,10.901125 L0.0588,0.13575 L2.07336,0.13575 L2.07336,2.538 C2.41032,1.835875 2.90376,1.228375 3.51228,0.766375 C4.04208,0.33475 4.68348,0.0785 5.35404,0.030625 L5.90088,0.030625 L5.85768,2.087625 Z",
          id: "path-15"
        }),
        React.createElement("path", {
          d: "M16.9153592,10.4534038 C17.303007,19.9696009 6.66483803,21.9010563 3.62147887,24.9180751 C1.98492958,19.6312207 0.234408451,5.95610329 0.234408451,5.95610329 C-0.555133803,2.62887324 1.22495775,-0.825117371 6.20619718,0.189906103 C6.20619718,0.189906103 16.5421972,0.951173709 16.9153592,10.4534038 Z",
          id: "path-17"
        }),
        React.createElement("path", {
          d: "M2.13211765,0 C4.95352941,2.65019149 7.50694118,6.03897872 7.84552941,9.83335461 C8.08094118,12.3410355 7.48435294,14.8569149 6.15258824,16.9729929 C2.72482353,16.3177092 0.198470588,13.3090709 0.0724705882,9.73195745 C-0.0556470588,6.36113475 0.653058824,3.01225532 2.13211765,0 Z",
          id: "path-19"
        }),
        React.createElement("path", {
          d: "M1.38755814,9.93790123 C0.96244186,9.87654321 0.533837209,9.84691358 0.104767442,9.84888889 C0.836744186,4.87382716 4.4422093,0.932222222 9.09802326,0.0171604938 L9.93465116,2.19703704 C9.93465116,2.19703704 2.18232558,2.65679012 1.38755814,9.93790123 Z",
          id: "path-21"
        }),
        React.createElement("path", {
          d: "M22.9337128,10.5055812 C22.9337128,17.3760785 13.7123641,20.3412723 13.7123641,22.9159476 C11.548359,21.3826545 6.1315641,19.3721414 2.69465641,15.3222147 C-0.835076923,11.2949267 -0.779876923,5.17957592 2.82204103,1.21960209 L3.06242051,0.944685864 C4.82811282,0.347528796 6.67613333,0.0447958115 8.53583077,0.0479267016 C10.3995385,-0.128727749 12.2163026,0.712397906 13.3162923,2.26098429 C13.3162923,2.26098429 22.9337128,2.20318325 22.9337128,10.5055812 Z",
          id: "path-23"
        }),
        React.createElement("path", {
          d: "M0.00711111111,0.135900406 L0.00711110606,0.115344246 C3.00974597,0.209486393 5.99221862,0.656722255 8.89647407,1.44804878 C13.2593778,2.72243902 16.0164741,7.58573171 15.9880296,9.25560976 C12.2260148,10.5736585 8.07336296,9.85841463 4.93143704,7.35134146 C2.67941647,5.45671729 0.975933072,2.96053363 0.00711110606,0.135899164 L0.00711111111,0.135900406 Z",
          id: "path-25"
        })
      ),
      React.createElement(
        "g",
        {
          id: "Logo-/-Light",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        },
        React.createElement("rect", {
          id: "Rectangle",
          fill: "#FFFFFF",
          opacity: "0",
          x: "0",
          y: "0",
          width: "120",
          height: "38"
        }),
        React.createElement(
          "g",
          { id: "Group-3", transform: "translate(40.090000, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-2", fill: "white" },
            React.createElement("use", { href: "#path-1" })
          ),
          React.createElement("g", { id: "Clip-2" }),
          React.createElement("polygon", {
            id: "Fill-1",
            fill: "#FCA715",
            mask: "url(#mask-2)",
            points: "0.0875 14.895122 10.9625 14.895122 10.9625 -0.00243902439 0.0875 -0.00243902439"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-6", transform: "translate(51.740002, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-4", fill: "white" },
            React.createElement("use", { href: "#path-3" })
          ),
          React.createElement("g", { id: "Clip-5" }),
          React.createElement("polygon", {
            id: "Fill-4",
            fill: "#FCA715",
            mask: "url(#mask-4)",
            points: "0.0321348315 10.9731111 10.9925843 10.9731111 10.9925843 0.0757777778 0.0321348315 0.0757777778"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-9", transform: "translate(63.250000, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-6", fill: "white" },
            React.createElement("use", { href: "#path-5" })
          ),
          React.createElement("g", { id: "Clip-8" }),
          React.createElement("polygon", {
            id: "Fill-7",
            fill: "#FCA715",
            mask: "url(#mask-6)",
            points: "0.0880952381 10.9877778 9.88809524 10.9877778 9.88809524 0.0171111111 0.0880952381 0.0171111111"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-12", transform: "translate(74.000000, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-8", fill: "white" },
            React.createElement("use", { href: "#path-7" })
          ),
          React.createElement("g", { id: "Clip-11" }),
          React.createElement("polygon", {
            id: "Fill-10",
            fill: "#FCA715",
            mask: "url(#mask-8)",
            points: "0.0313253012 10.9830769 9.93493976 10.9830769 9.93493976 0.0749450549 0.0313253012 0.0749450549"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-15", transform: "translate(86.000000, 12.000000)" },
          React.createElement(
            "mask",
            { id: "mask-10", fill: "white" },
            React.createElement("use", { href: "#path-9" })
          ),
          React.createElement("g", { id: "Clip-14" }),
          React.createElement("polygon", {
            id: "Fill-13",
            fill: "#FCA715",
            mask: "url(#mask-10)",
            points: "0.0530769231 13.9097521 8.92846154 13.9097521 8.92846154 -0.00231404959 0.0530769231 -0.00231404959"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-18", transform: "translate(93.830002, 12.000000)" },
          React.createElement(
            "mask",
            { id: "mask-12", fill: "white" },
            React.createElement("use", { href: "#path-11" })
          ),
          React.createElement("g", { id: "Clip-17" }),
          React.createElement("polygon", {
            id: "Fill-16",
            fill: "#FCA715",
            mask: "url(#mask-12)",
            points: "0.0984 18.9425 5.9592 18.9425 5.9592 -0.0025 0.0984 -0.0025"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-21", transform: "translate(101.410004, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-14", fill: "white" },
            React.createElement("use", { href: "#path-13" })
          ),
          React.createElement("g", { id: "Clip-20" }),
          React.createElement("polygon", {
            id: "Fill-19",
            fill: "#FCA715",
            mask: "url(#mask-14)",
            points: "0.0357142857 10.9731111 9.90714286 10.9731111 9.90714286 0.0611111111 0.0357142857 0.0611111111"
          })
        ),
        React.createElement(
          "g",
          { id: "Group-24", transform: "translate(113.000000, 15.000000)" },
          React.createElement(
            "mask",
            { id: "mask-16", fill: "white" },
            React.createElement("use", { href: "#path-15" })
          ),
          React.createElement("g", { id: "Clip-23" }),
          React.createElement("polygon", {
            id: "Fill-22",
            fill: "#FCA715",
            mask: "url(#mask-16)",
            points: "0.0504 10.9025 5.9112 10.9025 5.9112 0.0275 0.0504 0.0275"
          })
        ),
        React.createElement(
          "g",
          { id: "Group" },
          React.createElement(
            "g",
            { id: "Group-27", transform: "translate(12.800000, 12.600000)" },
            React.createElement(
              "mask",
              { id: "mask-18", fill: "white" },
              React.createElement("use", { href: "#path-17" })
            ),
            React.createElement("g", { id: "Clip-26" }),
            React.createElement("polygon", {
              id: "Fill-25",
              fill: "#F36A1F",
              mask: "url(#mask-18)",
              points: "0.0502816901 24.9854927 16.9302809 24.9854927 16.9302809 0.0699996948 0.0502816901 0.0699996948"
            })
          ),
          React.createElement(
            "g",
            { id: "Group-30", transform: "translate(10.000000, 0.000000)" },
            React.createElement(
              "mask",
              { id: "mask-20", fill: "white" },
              React.createElement("use", { href: "#path-19" })
            ),
            React.createElement("g", { id: "Clip-29" }),
            React.createElement("polygon", {
              id: "Fill-28",
              fill: "#3F833B",
              mask: "url(#mask-20)",
              points: "0.0447058824 16.9831206 7.90823529 16.9831206 7.90823529 -0.00241134752 0.0447058824 -0.00241134752"
            })
          ),
          React.createElement(
            "g",
            { id: "Group-33", transform: "translate(15.750000, 7.290000)" },
            React.createElement(
              "mask",
              { id: "mask-22", fill: "white" },
              React.createElement("use", { href: "#path-21" })
            ),
            React.createElement("g", { id: "Clip-32" }),
            React.createElement("polygon", {
              id: "Fill-31",
              fill: "#823E24",
              mask: "url(#mask-22)",
              points: "0.0953488372 9.94814815 9.94651163 9.94814815 9.94651163 0.00740740741 0.0953488372 0.00740740741"
            })
          ),
          React.createElement(
            "g",
            { id: "Group-36", transform: "translate(2.710000, 14.570000)" },
            React.createElement(
              "mask",
              { id: "mask-24", fill: "white" },
              React.createElement("use", { href: "#path-23" })
            ),
            React.createElement("g", { id: "Clip-35" }),
            React.createElement("polygon", {
              id: "Fill-34",
              fill: "#FCA715",
              mask: "url(#mask-24)",
              points: "0.0731282051 22.9205236 22.9457436 22.9205236 22.9457436 0.0168586387 0.0731282051 0.0168586387"
            })
          ),
          React.createElement(
            "g",
            { id: "Group-39", transform: "translate(0.000000, 7.860000)" },
            React.createElement(
              "mask",
              { id: "mask-26", fill: "white" },
              React.createElement("use", { href: "#path-25" })
            ),
            React.createElement("g", { id: "Clip-38" }),
            React.createElement("polygon", {
              id: "Fill-37",
              fill: "#67C06B",
              mask: "url(#mask-26)",
              points: "0.00711111111 9.9097561 15.9928889 9.9097561 15.9928889 0.104878049 0.00711111111 0.104878049"
            })
          )
        )
      )
    );
  };

  exports.default = PeachjarLogoLight;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/svg/PeachjarLogoLight.js
// module id = 2030
// module chunks = 1